import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getSuperbillFlow = asyncThunkWrapper({ 
  model: 'superbillFlows', 
  action: 'getSuperbillFlow', 
  func: async () => {
    const params = { attributes: ['id', 'before_in', 'start_at', 'time_zone', 'prompt', 'superbill_email', 'updated_at'] };
    const response = await axios.get(`/superbill_flow`, { params });

    return response.data;
  } 
});
export const createSuperbillFlow = asyncThunkWrapper({ 
  model: 'superbillFlows', 
  action: 'createSuperbillFlow', 
  func: async (superbill_flow) => {
    const attributes = ['id', 'before_in', 'start_at', 'time_zone', 'prompt', 'superbill_email', 'updated_at'];
    const response = await axios.post(`/superbill_flow`, { superbill_flow, attributes });

    return response.data;
  } 
});
export const updateSuperbillFlow = asyncThunkWrapper({ 
  model: 'superbillFlows', 
  action: 'updateSuperbillFlow', 
  func: async (superbill_flow) => {
    const response = await axios.patch(`/superbill_flow`, { superbill_flow });

    return { status: response.status, superbill_flow };
  } 
});
export const deleteSuperbillFlow = asyncThunkWrapper({ 
  model: 'superbillFlows', 
  action: 'deleteSuperbillFlow', 
  func: async () => {
    const response = await axios.delete(`/superbill_flow`);

    return { status: response.status };
  } 
});
export const clearLocalActiveSuperbillFlow = createAction('superbillFlows/clearLocalActiveSuperbillFlow');